/**
 * anim.ts — shared GSAP helpers for the configurator screens.
 *
 * wipeInHeading mirrors the theme's [data-wipe-heading] line wipe (SplitText →
 * masked lines, staggered yPercent reveal). The theme's global script only scans
 * headings present at DOMContentLoaded, so JS-rendered screens run this themselves
 * on mount (no ScrollTrigger — these headings are in view immediately).
 */

import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Line-wipe a heading element on mount. `el` is hidden until the split is ready. */
export function wipeInHeading(el: HTMLElement, delay = 0): void {
  if (REDUCE) { el.style.visibility = 'visible'; return; }
  el.style.visibility = 'hidden';
  const run = () => {
    try {
      el.style.visibility = 'visible';
      const split = new SplitText(el, { type: 'lines', mask: 'lines' });
      if (!split.lines.length) return;
      gsap.fromTo(split.lines,
        { yPercent: 105 },
        { yPercent: 0, ease: 'power3.out', duration: 0.9, stagger: 0.14, delay });
    } catch {
      el.style.visibility = 'visible'; // never leave the heading hidden
    }
  };
  // Wait for fonts so the line splitting matches the rendered display face.
  if (document.fonts?.ready) document.fonts.ready.then(run); else run();
}
